import React, { Component } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import "./assets/css/Footer.css";
import Award1 from "./assets/images/footer-award-1.png";
import Award2 from "./assets/images/footer-award-2.png";
import Award3 from "./assets/images/footer-award-3.png";
import GlobalVariables from "./GlobalVariables";

const lang = "";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.lang = props.lang ? props.lang : "";
  }

  getLangText(langJson) {
    return GlobalVariables.currentLang
      ? langJson[GlobalVariables.currentLang]
      : langJson["tc"];
  }

  getLink(page) {
    if (GlobalVariables.currentLang == "tc") {
      return page ? "/" + page : "";
    }

    if (page == "") {
      return GlobalVariables.currentLang
        ? "/" + GlobalVariables.currentLang
        : "/" + page;
    } else {
      return GlobalVariables.currentLang
        ? "/" + GlobalVariables.currentLang + "/" + page
        : "/" + page;
    }
  }

  render() {
    return FooterJSX(this);
  }
}

// The Footer creates links that can be used to navigate
// between routes.
const FooterJSX = ctx => (
  <footer>
    <div
      className={"footer" + (GlobalVariables.currentLang === "en" ? " en" : "")}
    >
      {/* <Grid container id="award-bar-parent" spacing={0}>
        <Grid container id="award-bar" spacing={0}>
          <Grid item className="award-title">
            <span style={{ textDecoration: "none", color: "#BFBFBF" }}>
              {ctx.getLangText({
                tc: "獲得獎項",
                sc: "获得奖项",
                en: "Awards"
              })}
            </span>
          </Grid>

          <Grid item className="award-item">
            <Grid container className="award-item-container" spacing={0}>
              <Grid item className="award-img">
                <img
                  src={Award1}
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    width: "45px",
                    height: "45px"
                  }}
                />
              </Grid>
              <Grid item className="award-desc">
                <span>
                  {ctx.getLangText({
                    tc: "第十三屆",
                    sc: "第十三届",
                    en: "13th China"
                  })}
                  <br />
                  {ctx.getLangText({
                    tc: "中國財經風雲榜",
                    sc: "中国财经风云榜",
                    en: "Financial Ranking"
                  })}
                </span>
              </Grid>
            </Grid>
          </Grid>

          <Grid item className="award-item">
            <Grid container className="award-item-container" spacing={0}>
              <Grid item className="award-img">
                <img
                  src={Award2}
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    width: "45px",
                    height: "45px"
                  }}
                />
              </Grid>
              <Grid item className="award-desc">
                <span>
                  {ctx.getLangText({
                    tc: "2016 / 2017",
                    sc: "2016 / 2017",
                    en: "2016 / 17 Best Value Added"
                  })}
                  <br />
                  {ctx.getLangText({
                    tc: "傑出金商增值服務大獎",
                    sc: "杰出金商增值服务大奖",
                    en: "Services Bullion Platform"
                  })}
                </span>
              </Grid>
            </Grid>
          </Grid>

          <Grid item className="award-item">
            <Grid container className="award-item-container" spacing={0}>
              <Grid item className="award-img">
                <img
                  src={Award3}
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    width: "45px",
                    height: "45px"
                  }}
                />
              </Grid>
              <Grid item className="award-desc">
                <span>
                  {ctx.getLangText({
                    tc: "2015",
                    sc: "2015",
                    en: "2015 Top 10"
                  })}
                  <br />
                  {ctx.getLangText({
                    tc: "十佳黃金交易平台",
                    sc: "十佳黄金交易平台",
                    en: "Gold Trading Platform"
                  })}
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid> */}

      <Grid id="footer-bar-parent" container spacing={0} justify="flex-end">
        <Grid id="footer-bar" container spacing={0}>
          <Grid className="footer-bar-link-parent" container item>
            <Grid item className="footer-link">
              <Button className="footer-link-btn">
                <Link
                  to={ctx.getLink("career")}
                  style={{ textDecoration: "none", color: "#FFF" }}
                >
                  <span className="footer-link-text">
                    {ctx.getLangText({
                      tc: "職位空缺",
                      sc: "职位空缺",
                      en: "Careers"
                    })}
                  </span>
                </Link>
              </Button>
            </Grid>

            {/* <Grid item className="footer-link">
              <Button className="footer-link-btn">
                <Link
                  to={ctx.getLink("privacy-policy")}
                  style={{ textDecoration: "none", color: "#FFF" }}
                >
                  <span className="footer-link-text">
                    {ctx.getLangText({
                      tc: "私隱政策",
                      sc: "私隐政策",
                      en: "Privacy Policy"
                    })}
                  </span>
                </Link>
              </Button>
            </Grid>

            <Grid item className="footer-link">
              <Button className="footer-link-btn">
                <Link
                  to={ctx.getLink("disclaimer")}
                  style={{ textDecoration: "none", color: "#FFF" }}
                >
                  <span className="footer-link-text">
                    {ctx.getLangText({
                      tc: "免責聲明及使用條款",
                      sc: "免责声明及使用条款",
                      en: "Disclaimer/T&C"
                    })}
                  </span>
                </Link>
              </Button>
            </Grid> */}

            <Grid item className="footer-bar-copyright-parent">
              <span>&copy; 2018 FxHB Group. All Rights Reserved.</span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js